import { dtoToDeliveriesTracking } from './transformers/deliveriesTracking';
import { DeliveryTrackingDto } from './dtos/deliveriesTracking';
import { sagwClient } from './clients';

export function fetchTrackingDeliveriesData(deliveryIds: string[]) {
  return sagwClient
    .get<DeliveryTrackingDto[]>('/mot/deliveries/track', {
      params: {
        booking_ids: deliveryIds.join(',')
      }
    })
    .then(dtoToDeliveriesTracking);
}
